import React from "react";

import {
  GlobalSearchContactResult,
  GlobalSearchCompanyResult,
  GlobalSearchRequestResult,
  GlobalSearchTripInfo,
} from "types";
import { UserIcon, CompanyIcon, ReservationIcon } from "design-system/icons";
import { grayDark } from "design-system/colors";
import { SearchResultTypename } from "../../../types";
import SearchResultItem from "./SearchResultItem";
import RelatedTripsSection from "./RelatedTripsSection";
import {
  getSearchResultDisplayName,
  getSearchResultSecondaryInfo,
  getSearchResultRelatedTrips,
} from "./searchResultUtils";

const { Contact, Company, Request } = SearchResultTypename;

type SearchResult =
  | GlobalSearchContactResult
  | GlobalSearchCompanyResult
  | GlobalSearchRequestResult;

type GlobalSearchResultListItemProps = {
  searchResult: SearchResult;
  searchTerm?: string;
  onClick: (searchResult: SearchResult) => void;
  onTripClick?: (trip: GlobalSearchTripInfo) => void;
  isSelected?: boolean;
  showRelatedTrips?: boolean;
};

function GlobalSearchResultListItem(props: GlobalSearchResultListItemProps) {
  const { searchResult, onClick, onTripClick, isSelected, showRelatedTrips = false } = props;

  const displayName = props.searchTerm || getSearchResultDisplayName(searchResult);
  const secondaryInfo = getSearchResultSecondaryInfo(searchResult);
  const relatedTrips = getSearchResultRelatedTrips(searchResult);

  const icon = {
    [Contact]: <UserIcon color={grayDark} size="small" />,
    [Company]: <CompanyIcon color={grayDark} size="small" />,
    [Request]: <ReservationIcon color={grayDark} />,
  }[searchResult.__typename || ""];

  const handleClick = () => {
    onClick(searchResult);
  };

  const handleTripClick = (trip: GlobalSearchTripInfo) => {
    if (onTripClick) {
      onTripClick(trip);
    }
  };

  return (
    <>
      <SearchResultItem
        icon={icon}
        primaryText={displayName}
        secondaryText={secondaryInfo}
        onClick={handleClick}
        isSelected={isSelected}
      />
      
      <RelatedTripsSection
        trips={relatedTrips}
        onTripClick={handleTripClick}
        show={showRelatedTrips}
      />
    </>
  );
}
export default GlobalSearchResultListItem;
